module.exports = __webpack_public_path__ + "static/media/ubereats.2e98c33b.png";